import React from "react";

const Unit = () => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_3199_681)">
        <rect
          x="4"
          y="4.04688"
          width="16"
          height="16.1264"
          rx="4"
          fill="#DAF3FF"
        />
      </g>
      <path
        d="M7.78125 12.8259V16.374H11.3015V14.8685H12.7089V16.374H16.2291V12.8259H14.7354V11.4075H16.2291V7.85938H12.7089V9.36488H11.3015V7.85938H7.78125V11.4075H9.27496V12.8259H7.78125ZM10.7255 15.7935H8.35725V13.4065H10.7255V15.7935ZM15.6533 15.7935H13.285V13.4065H15.6533V15.7935ZM13.285 8.43982H15.6533V10.8268H13.285V8.43982ZM8.35725 8.43982H10.7255V10.8268H8.35725V8.43982ZM9.85103 11.4074H11.3016V9.94533H12.7089V11.4074H14.1595V12.8258H12.7089V14.2878H11.3016V12.8258H9.85103V11.4074Z"
        fill="#0094D9"
      />
      <defs>
        <filter
          id="filter0_d_3199_681"
          x="0"
          y="0.046875"
          width="24"
          height="24.125"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_3199_681"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_3199_681"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export default Unit;
